/**
 * M15 — setup chip. One at a time; the reason IS the copy (`reasonText`).
 * Contacts and calendar sync are app-only, so when the payload says
 * `appOnly` the chip becomes `WebAppChip` and links to /download itself. The
 * other kinds emit `open`; the host's route map opens the existing settings
 * / profile screens.
 */

import { HomeSetupChip } from '../HomeKit';
import { SETUP_LABEL, WebAppChip } from '../WebAppChip';
import type { ModuleProps } from '../moduleTypes';

export function SetupModule({ module, onAction }: ModuleProps) {
  if (module.type !== 'setup') return null;
  const { payload } = module;
  const act = (a: Parameters<NonNullable<typeof onAction>>[0]) => onAction?.(a, module);
  const dismiss = module.dismissable ? () => act({ kind: 'dismiss', dismissKey: module.dismissKey }) : undefined;

  if (payload.appOnly) {
    return <WebAppChip kind={payload.kind} sub={payload.reasonText} dismissable={module.dismissable} onDismiss={dismiss} />;
  }

  return (
    <HomeSetupChip
      kind={payload.kind}
      body={SETUP_LABEL[payload.kind]}
      sub={payload.reasonText}
      dismissable={module.dismissable}
      onDismiss={dismiss}
      onOpen={() => act({ kind: 'open' })}
    />
  );
}
